import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70feeaf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "table-header"
}
const _hoisted_3 = {
  key: 1,
  class: "table-footer"
}

import { computed, useSlots } from 'vue';
import {
  Column,
  ColumnRaw,
  SortOrder,
  TableComponentParams,
  TableDataManager,
  TableViewComponentParams,
} from './types';
import _ from "lodash";
import TableView from "@ui-kit/table/table-view/TableView.vue";
import Pagination from "@ui-kit/pagination/Pagination.vue";
import PaginationDetails from '@ui-kit/pagination/PaginationDetails.vue';
import SingleLine from "@ui-kit/inputs/single-line/SingleLine.vue";

interface Props {
  dataManager: TableDataManager;
  params: TableComponentParams;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Table',
  props: {
    dataManager: null,
    params: null
  },
  setup(__props: any) {

const props = __props as {
  dataManager: TableDataManager;
  params: TableComponentParams;
}



const columns = computed<ColumnRaw[]>(() => {
  const getColumnSort = (col: Column): SortOrder|undefined => {
    if (!col.sortable) return undefined;

    const sortOrderValue = props.dataManager.getSortOrder();
    if (sortOrderValue && sortOrderValue.column === col.name) return sortOrderValue.order;
    return SortOrder.AUTO;
  }

  const filteredColumns = props.params.columns.filter(({ hidden }) => !hidden);
  return filteredColumns.map((col) => ({
    ..._.omit(col, ['sortable', 'hidden']),
    sort: getColumnSort(col),
  }));
});

const tableViewParams = computed<TableViewComponentParams>(() => {
  return {
    columns: columns.value,
    expandable: props.params.expandable,
    selectable: props.params.selectable,
    rows: props.dataManager.getData(),
    loading: props.dataManager.isLoading(),
  };
});

const slotNames = computed(() => {
  const columns = props.params.columns;
  return {
    headers: columns.map(({name}) => `header-${name}`),
    cells: columns.map(({name}) => `cell-${name}`),
  }
});

function toggleSort(column: Column) {
  const sortOrderValue = props.dataManager.getSortOrder();
  if (sortOrderValue && sortOrderValue.column === column.name){
    switch (sortOrderValue.order){
      case SortOrder.AUTO: props.dataManager.setSortOrder({column: column.name, order: SortOrder.ASC}); break;
      case SortOrder.ASC: props.dataManager.setSortOrder({column: column.name, order: SortOrder.DESC}); break;
      case SortOrder.DESC: props.dataManager.setSortOrder(); break;
    }
  } else {
    props.dataManager.setSortOrder({
      column: column.name,
      order: SortOrder.ASC,
    });
  }
}

const slots = useSlots();
const showTableHeader = computed<boolean>(() => {
  const { 'header-left': headerLeft, 'header-right': headerRight } = slots;
  return Boolean(headerLeft || headerRight || props.params.searchable !== false);
});

const paginationData = computed(() => {
  return props.dataManager.getPaginationData();
});
const showPagination = computed<boolean>(() => {
  return Boolean(paginationData.value && paginationData.value.pageCount > 1);
});
const showTableFooter = computed<boolean>(() => {
  return showPagination.value;
});
const paginationDetails = computed(() => {
  const paginationDataValue = paginationData.value;
  if (paginationDataValue) {
    return {
      total: paginationDataValue.rowsCount,
      from: (paginationDataValue.page - 1) * paginationDataValue.perPage + 1,
      to: Math.min(paginationDataValue.rowsCount, paginationDataValue.page * paginationDataValue.perPage)
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showTableHeader))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "header-left")
          ]),
          _createElementVNode("div", null, [
            (__props.params.searchable !== false)
              ? (_openBlock(), _createBlock(SingleLine, {
                  key: 0,
                  "model-value": __props.dataManager.getSearch(),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (__props.dataManager.setSearch($event))),
                  placeholder: _ctx.$t('components.table.search')
                }, null, 8, ["model-value", "placeholder"]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "header-right")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(TableView, {
      params: _unref(tableViewParams),
      onToggleSort: toggleSort
    }, _createSlots({
      "responsive-expanded": _withCtx((scope) => [
        _renderSlot(_ctx.$slots, "responsive-expanded", {
          row: scope.row,
          columns: scope.columns
        })
      ]),
      expanded: _withCtx((scope) => [
        _renderSlot(_ctx.$slots, "expanded", {
          row: scope.row
        })
      ]),
      _: 2
    }, [
      _renderList(_unref(slotNames).headers, (name) => {
        return {
          name: name,
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, name, {
              column: scope.column
            })
          ])
        }
      }),
      _renderList(_unref(slotNames).cells, (name) => {
        return {
          name: name,
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, name, {
              row: scope.row,
              column: scope.column,
              value: scope.value
            })
          ])
        }
      })
    ]), 1032, ["params"]),
    (_unref(showTableFooter))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            (_unref(showPagination))
              ? (_openBlock(), _createBlock(PaginationDetails, {
                  key: 0,
                  total: _unref(paginationDetails).total,
                  from: _unref(paginationDetails).from,
                  to: _unref(paginationDetails).to
                }, null, 8, ["total", "from", "to"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_unref(showPagination))
              ? (_openBlock(), _createBlock(Pagination, {
                  key: 0,
                  page: __props.dataManager.getPaginationData().page,
                  "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => (__props.dataManager.setPage($event))),
                  "page-count": __props.dataManager.getPaginationData().pageCount
                }, null, 8, ["page", "page-count"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})